import { withTranslation } from "react-i18next";

import MyTicketBoard from './MyTicketBoard';

export default withTranslation(undefined, { withRef: true })(MyTicketBoard);